import { forwardRef, useContext } from 'react';

import { type ButtonProps, TailwindButton } from '../../../../tailwind';
import { AdvancedFiltersContext } from '../../advanced-filters/v1/AdvancedFilters.context';
import { GeneralFiltersContext } from '../../general-filters/GeneralFilters.context';
import { useActiveFiltersCount } from '../hooks';

export const ClearAllButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, ...props }, ref) => {
    // check which contexts are provided
    const generalFiltersContext = useContext(GeneralFiltersContext);
    const advancedFiltersContext = useContext(AdvancedFiltersContext);
    const { setToggledOptions } = generalFiltersContext || {};
    const [, dispatch] = advancedFiltersContext || [];

    const { activeFiltersCount } = useActiveFiltersCount();

    const handleOnClick = () => {
      if (setToggledOptions) {
        setToggledOptions({});
      }
      if (dispatch) {
        dispatch({ type: 'RESET' });
      }
    };

    return (
      <TailwindButton
        onClick={handleOnClick}
        className={className}
        variant={'outlined'}
        color={'secondary'}
        disabled={!activeFiltersCount}
        {...props}
        ref={ref}
      />
    );
  },
);
